import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AccountRepository from "src/repository/Admin/AccountRepository";

export const getAccountList = createAsyncThunk('get_account_list', async (params) => {
    return await new AccountRepository().getAccountList(params)
});

export const getAccountDetail = createAsyncThunk('get_account_detail', async (params) => {
    return await new AccountRepository().getAccountDetail(params)
});

export const getAccountUserList = createAsyncThunk('get_account_user_list', async (params) => {
    return await new AccountRepository().getAccountUserList(params)
});


const slice = createSlice({
    name: "Accounts",
    initialState: {
        totalRecords: 0,
        filteredRecords: 0,
        totalAccountUser: 0,
        filteredAccountUsers: 0,
        accountList: [],
        accountDetail: {},
        accountUserList: [],
    },
    reducers: {
        setAccountList: {
            reducer: (state, action) => {
                state.accountList = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getAccountList.fulfilled]: (state, action) => {
            state.accountList = action.payload.accounts;
            state.filteredRecords = action.payload.accounts?.length;
            state.totalRecords = action.payload.total;
        },
        [getAccountDetail.fulfilled]: (state, { payload }) => {
            state.accountDetail = payload
        },
        [getAccountUserList.fulfilled]: (state, { payload }) => {
            state.accountUserList = payload.data?.accountSpecificList;
            state.totalAccountUser = payload.data?.total;
            state.filteredAccountUsers = payload.data?.accountSpecificList?.length;
        },
    },
});



export let { setAccountList, } = slice.actions;

export default slice.reducer;
